export default {
  query: 'fees',
  results: [
    {
      title: 'Peer Group & Database',
      children: [
        {
          path: ['Participants'],
          title: 'Participants Chart 1',
          chartId: '1b3f7e27-d92a-4b73-a767-9cf0e91de0ce',
          snippet: ['which management fees are charged'],
        },
        {
          path: ['Participants', 'Participants Chart 1'],
          title: 'Drilldown Test 1',
          snippet: [
            'All base fees, before rebates',
            "investment management fees, manager-of-managers fees, commitment fees and 'hidden' fees netted from",
          ],
        },
        {
          path: ['Participants', 'Participants Chart 1', 'Drilldown Test 1'],
          title: 'Drilldown Test 1.1',
          snippet: [
            'Base fees, before rebates',
            "investment management fees, commitment fees and 'hidden' fees netted from",
          ],
        },
        {
          path: ['Participants'],
          title: 'Participants Chart 2',
          chartId: 'ae34bf45-5c85-4be5-8885-157cb7cd40b5',
          snippet: [
            'credited against fees. Also they',
            'benefit checks. Fees for performance',
          ],
        },
        {
          path: ['Participants'],
          title: 'Participants Chart 3',
          chartId: 'e615250f-57f0-4d60-91d5-fad14a7fa6db',
          snippet: [
            'comparability performance fees should be',
            'method, performance fees are reported',
          ],
        },
        {
          path: ['Peer Names'],
          title: 'Peer Names Chart 2',
          chartId: '7996d886-db25-4e3e-9ec3-6c07c2d01dea',
          snippet: [
            'and the fees/salaries of',
            'above including fees/salaries, travel',
          ],
        },
        {
          path: ['Peer Names'],
          title: 'Peer Names Chart 3',
          chartId: 'ccff9a8b-17a2-4a50-abb6-48788b5e2a19',
          snippet: [
            'Performance fees and carried',
            'comparability performance fees should be reported',
            'method, performance fees are reported',
          ],
        },
        {
          path: ['Plan size (AUM)'],
          title: 'Plan size (AUM) Chart 1',
          snippet: ['which management fees are charged'],
        },
        {
          path: ['Summary'],
          title: 'Summary Chart 2',
          snippet: ['which management fees are charged'],
        },
        {
          path: ['Summary'],
          title: 'Summary Chart 2',
          snippet: [
            'All base fees, before rebates',
            "investment management fees, manager-of-managers fees, commitment fees and 'hidden' fees netted from",
          ],
        },
      ],
    },
    {
      title: 'Performance',
      children: [
        {
          path: ['Total plan performance'],
          title: 'Total plan performance Chart 1',
          chartId: 'e594652b-4fdb-4a34-a1c3-5b3057ae2664',
          snippet: [
            'Base fees, before rebates',
            "investment management fees, commitment fees and 'hidden' fees netted",
          ],
        },
        {
          path: ['Total plan performance'],
          title: 'Total plan performance Chart 3',
          chartId: '9e624cd5-c908-4cc4-9728-e40869b8b4ba',
          snippet: [
            'credited against fees. Also they',
            'benefit checks. Fees for performance',
          ],
        },
        {
          path: ['Cost Benchmark'],
          title: 'Cost Benchmark Chart 1',
          chartId: 'aafcb4ff-a115-461d-a764-1f09e258c103',
          snippet: [
            'all performance fees and carried',
            'comparability performance fees should be',
            'method, performance fees are reported',
          ],
        },
        {
          path: ['Cost Benchmark'],
          title: 'Cost Benchmark Chart 2',
          chartId: '09b29a24-7333-466a-a3f6-ded9454b6666',
          snippet: [
            'and the fees/salaries of',
            'above including fees/salaries, travel',
          ],
        },
        {
          path: ['Reasons for differences'],
          title: 'Reasons for differences Chart 1',
          snippet: [
            'Performance fees and carried',
            'comparability performance fees should be',
            'method, performance fees are reported',
          ],
        },
        {
          path: ['Reasons for differences'],
          title: 'Reasons for differences Chart 2',
          snippet: ['which management fees are charged'],
        },
      ],
    },
  ],
}
